/**
 * @generated SignedSource<<91a1e36560d38b4e53401035da26c0a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApprovalStyle = "AUTOMATIC" | "MANUAL" | "%future added value";
export type UpdateCapabilityInput = {
  approvalStyle?: ApprovalStyle | null | undefined;
  description?: string | null | undefined;
  id: any;
  integrationId?: any | null | undefined;
  isActive?: boolean | null | undefined;
  name?: string | null | undefined;
  parametersSchema?: any | null | undefined;
  targetConfig?: any | null | undefined;
};
export type CapabilityDetailUpdateMutation$variables = {
  input: UpdateCapabilityInput;
};
export type CapabilityDetailUpdateMutation$data = {
  readonly updateCapability: {
    readonly capability: {
      readonly id: any;
      readonly isActive: boolean;
      readonly name: string;
    } | null | undefined;
    readonly error: string | null | undefined;
  };
};
export type CapabilityDetailUpdateMutation = {
  response: CapabilityDetailUpdateMutation$data;
  variables: CapabilityDetailUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCapabilityPayload",
    "kind": "LinkedField",
    "name": "updateCapability",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCapability",
        "kind": "LinkedField",
        "name": "capability",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CapabilityDetailUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CapabilityDetailUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ac631fc0245417c17ea0ca418a4d28c",
    "id": null,
    "metadata": {},
    "name": "CapabilityDetailUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CapabilityDetailUpdateMutation(\n  $input: UpdateCapabilityInput!\n) {\n  updateCapability(input: $input) {\n    capability {\n      id\n      name\n      isActive\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "33fd07579de7d1d85100a51884f683bc";

export default node;
